var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.66 62.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M50.16 35.61a30 30 0 0 0-11.54-1.39c-7.39.58-16.51 3.57-21.52 3.57a51.8 51.8 0 0 1-15.6-2.18V2.85S4.62 5 17.72 5c6.46 0 14.44-2.9 20.86-3.43a29.9 29.9 0 0 1 11.58 1.28zM1.5 61.18V35.92",
    "data-name": "Layer 67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFlag);
export default __webpack_public_path__ + "static/media/statusFlag.bba1d37b3393330a458458acd4ba1d7b.svg";
export { ForwardRef as ReactComponent };